import { useState } from 'react';

/**
 * Which invoice lines are checked for aggregating. Lines that left the table
 * or joined an aggregated match since being checked drop out of
 * `selectedLines`, so the action bar never offers a stale selection.
 */
export function useLineSelection<T extends { id: string }>(
  lines: readonly T[],
  isSelectable: (line: T) => boolean,
) {
  const [selectedIds, setSelectedIds] = useState<ReadonlySet<string>>(
    () => new Set(),
  );
  const toggle = (lineId: string, selected: boolean) => {
    setSelectedIds((current) => {
      const next = new Set(current);
      if (selected) next.add(lineId);
      else next.delete(lineId);
      return next;
    });
  };
  const clear = () => setSelectedIds(new Set());
  const selectedLines = lines.filter(
    (line) => selectedIds.has(line.id) && isSelectable(line),
  );
  return { selectedIds, selectedLines, toggle, clear };
}
